import { oauth2Login, oauth2Logout } from '@creditornot/wolt-auth';

import { authService } from './authService';
import { authenticator } from './authenticator';
import { handleLogout } from './logout';

export async function handleOAuth2LoginCallback() {
  try {
    await oauth2Login({ ...authenticator, authService });
    location.href = '/';
  } catch (error) {
    console.error(error);
    location.href = '/login';
  }
}

export async function handleOAuth2LogoutCallback() {
  await oauth2Logout(authenticator);
  await handleLogout();
}
